import React, { forwardRef } from 'react';
import { styled, Container } from '@mui/material';

const CustomContainer = styled(Container)(({ device, theme }) => {
    return {
        ...(device === 'mobile' && {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            height: 'fit-content',
            minHeight: '100%',
            padding: theme.spacing(5, 5, 0),
            background: theme.palette.ensightful.shades[0],
        }),
        ...(device === 'tablet' && {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            height: 'fit-content',
            minHeight: '100%',
            padding: theme.spacing(5, 5, 0),
        }),
        ...(device === 'desktop' && {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            maxWidth: '1440px',
            height: 'fit-content',
            minHeight: '100%',
            padding: theme.spacing(5, 10, 0),
        }),
    };
});

export default forwardRef(({ device, ...rest }, ref) => {
    return <CustomContainer ref={ref} device={device} {...rest} />;
});
